// extracted by mini-css-extract-plugin
export default {"header":"UserDetailsPage_header__1raZY","nameText":"UserDetailsPage_nameText__CWW8O","fields":"UserDetailsPage_fields__+Xh+E"};